const posts = [
  {
    id: 1,
    profileAvatar:
      "https://pixinvent.com/materialize-material-design-admin-template/app-assets/images/user/12.jpg",
    timestamp: "30 minutes ago",
    location: "Johor Bahru",
    cancelationFee: "Free cancellation",
    description:
      "dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into",
    tags: ["#Electrical", "#Job", "#Free", "#People"],
    proposals: 6,
    postAuthor: false,
  },
  {
    id: 2,
    profileAvatar:
      "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    timestamp: "40 minutes ago",
    location: "Johor Bahru",
    cancelationFee: "Free cancellation",
    description:
      "dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into",
    tags: ["#Electrical", "#Job", "#Free", "#People"],
    proposals: 9,
    postAuthor: true,
  },
  {
    id: 3,
    profileAvatar:
      "https://pixinvent.com/materialize-material-design-admin-template/app-assets/images/user/12.jpg",
    timestamp: "1 hour ago",
    location: "Kuala Lumper",
    cancelationFee: "Free cancellation",
    description:
      "dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into",
    tags: ["#Electrical", "#Job", "#Free", "#People"],
    proposals: 4,
    postAuthor: false,
  },
];

export default posts;
